// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__m6NSp","header":"ReportDetails_header__3-Bhj","title":"ReportDetails_title__yHacp","left":"ReportDetails_left__1jhwk"};